export function accordion() {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(accordion => {
        const header = accordion.querySelector('.accordion__header');
        const content = accordion.querySelector('.accordion__content');

        header.addEventListener('click', () => {
            const isActive = accordion.classList.contains('accordion--active');
            
            accordions.forEach(item => {
                if (item !== accordion) {
                    item.classList.remove('accordion--active');
                    const itemContent = item.querySelector('.accordion__content');
                    itemContent.style.maxHeight = null;
                }
            });

            if (isActive) {
                accordion.classList.remove('accordion--active');
                content.style.maxHeight = null;
            } else {
                accordion.classList.add('accordion--active');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
}